// Helpers de formatação pt-BR
export function fmtBRL(v, casas = 2) {
  if (v == null || isNaN(v)) return '—';
  const n = Number(v);
  return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
}
export function fmtNum(v, casas = 0) {
  if (v == null || isNaN(v)) return '—';
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
}
export function fmtDate(s) {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString('pt-BR');
}
export function fmtDateTime(s) {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
export function escapeHtml(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}
export function diasBadge(dias) {
  if (dias > 180) return '<span class="nd-badge crit">CRÍTICO ' + dias + 'd</span>';
  if (dias >  90) return '<span class="nd-badge high">ALTO ' + dias + 'd</span>';
  if (dias >  30) return '<span class="nd-badge med">MÉDIO ' + dias + 'd</span>';
  if (dias >   7) return '<span class="nd-badge low">' + dias + 'd</span>';
  return '<span class="nd-badge ok">' + dias + 'd</span>';
}
export function valorRiscoBadge(v) {
  if (!v) return '';
  if (v >= 5000) return '<span class="nd-badge crit">ALTO</span>';
  if (v >= 3000) return '<span class="nd-badge high">MÉDIO</span>';
  return '';
}
